import React from "react";
interface StartSessionProps {
  toggleDashboard: () => void;
}
const StartSession: React.FC<StartSessionProps> = ({ toggleDashboard }) => {
  return (
    <div className="text-center mb-6">
      <button
        onClick={toggleDashboard}
        className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-4 px-12 rounded-2xl shadow-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
      >
        <div className="flex items-center gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
              clipRule="evenodd"
            />
          </svg>
          <span className="text-lg">Start Session</span>
        </div>
      </button>
    </div>
  );
};
export default StartSession;
